<template>
  <div class="container">
	<b-row>
		<b-col md="6" class="pr-md-3 mt-2 mt-md-0 p-0">
			<div>
				<h5 class="section-title">{{params.trans['market_releases']}}</h5>
				<Slider v-bind:items="params['market_releases']['slider_items']" v-bind:settings="slider_settings" v-bind:page="'investors'"></Slider>
			</div>
		</b-col>
  	</b-row>
  </div>
</template>
<script>
import Slider from '@/components/Slider.vue'

export default {
	name: 'investors_info',
	components: {
		Slider
	},
	props: ['params'],
	data() {
		return {
			slider_settings: {
				main_class: 'investors-info',
				mouseDrag: false,
				shortDrag: false, // so it won't slide on mobile screen just by touching it
				transition: 600,
				wheelControl: false,
				initialSlide: 0,
				infiniteScroll: true,
				centerMode: false,
				itemsToSlide: 1,
				breakpoints: {
		            0: {
		              itemsToShow: 3,
		              // centerMode: false,
		              // pagination: 'indicator'
		            },
		            991.98: {
					  itemsToShow: 3
		              // pagination: 'fraction'
		            },
					1200: {
					  itemsToShow: 3
					}
	          	}
	        }
		}
	}
	/*created() {
		console.log(this.params);
	}*/
}
</script>
<style>

</style>